import MicrophoneIcon from '@/assets/svg/microphone.svg?react';
import { Button } from '@/components/buttons';
import { cn } from '@/lib/utils';

type Props = {
  className?: string;
  isRecording: boolean;
  onRecordingChange: (isRecording: boolean) => void;
  size?: 'small' | 'medium' | 'large';
};

const sizeClassNames = {
  small: 'size-5',
  medium: 'size-6',
  large: 'size-7',
} as const;

const iconSizeMap = {
  small: 'icon-small',
  medium: 'icon',
  large: 'icon-large',
} as const;

const MicrophoneButton = ({
  className = '',
  isRecording,
  onRecordingChange,
  size = 'medium',
}: Props) => {
  return (
    <Button
      variant="ghost"
      className={cn(
        'relative rounded-full',
        isRecording && [
          'bg-aqua-400 text-white',
          'hover:bg-aqua-400! hover:text-white!',
          'active:bg-aqua-500! active:text-white!',
          'before:absolute before:-inset-[3.5px] before:rounded-full before:border-1.5 before:border-aqua-400 before:content-[""]',
          'after:absolute after:-inset-[3.5px] after:scale-100 after:rounded-full after:shadow-[0_0_0_0_rgb(89,189,198)] after:content-[""]',
          'after:animate-[microphone-pulse_2s_infinite]',
        ],
        sizeClassNames[size],
        className,
      )}
      size={iconSizeMap[size]}
      onClick={() => onRecordingChange(!isRecording)}
    >
      <MicrophoneIcon />
    </Button>
  );
};

export default MicrophoneButton;
